<template>
  <div class="card">
    <h2 class="title">Aanmelden</h2>
    <div v-if="isDevEnv">
      <button type="button" class="btn btn-sandpiper" @click="devAutoCredentials">Dev credentials</button>
    </div>
    <form @submit.prevent="onSubmit">
      <div class="form-group">
        <label for="loginUsername">E-mailadres</label>
        <input id="loginUsername" type="text" class="form-control" v-model="username" autocomplete="username">
      </div>
      <div class="form-group">
        <label for="loginPassword">Wachtwoord</label>
        <input id="loginPassword" type="password" class="form-control" v-model="password" autocomplete="current-password">
      </div>
      <div class="form-feedback" v-if="formFeedback">
        {{ formFeedback }}
      </div>
      <div>
        <a class="text-button" href="#" v-on:click.prevent="forgotPassword">Wachtwoord vergeten</a>
      </div>

      <div>
        <a class="text-button" href="#" v-on:click.prevent="registerClicked">Account aanmaken</a>
      </div>

      <div class="form-group">
        <v-button :enabled="true" :buttonText="'Aanmelden'" type="submit"></v-button>
      </div>
    </form>

    <v-modal v-if="errorDialog.show" @close="errorDialog.show = false">
      <template v-slot:header>
        <h3>{{ errorDialog.title }}</h3>
      </template>
      <template v-slot:body>
        <p>
          {{ errorDialog.body }}
        </p>
      </template>
    </v-modal>
  </div>
</template>

<script>
import { AuthApi } from 'sandpiper_api'
import VButton from "@/components/UI/VButton";
import log from "@/utils/logger";
import { mapActions } from "vuex";
import DevUtils from "@/mixins/DevUtils";

export default {
  name: "Login",
  components: { VButton },
  mixins: [ DevUtils ],
  data()
  {
    return {
      username: '',
      password: '',
      formFeedback: '',

      errorDialog: {
        show: false,
        title: "",
        body: ""
      }
    }
  },
  methods: {
    devAutoCredentials()
    {
      this.username = 'sandpiper-dev@cartamundi-digital.com';
      this.password = 'test';
    },
    ...mapActions({ login: "security/login" }),
    forgotPassword()
    {
      this.$router.push({ name: 'forgot-password' });
    },
    registerClicked()
    {
      this.$router.push({ name: 'register' });
    },
    async onSubmit()
    {
      try
      {
        const userLogin = {
          username: this.username,
          password: this.password
        };

        log.info("Authenticating...");
        const response = await new AuthApi().authLogin(userLogin);
        log.info("Authenticated: %o", response);

        this.login(response.access_token);

        await this.$router.push("/");
      }
      catch (e)
      {
        log.error(e);

        if (e.body?.error === "ACCOUNT_NOT_ACTIVATED")
        {
          this.errorDialog.title = "Account niet geactiveerd"
          this.errorDialog.body = "Jouw account is nog niet geactiveerd. Om jouw account te activeren klik je op de link in de e-mail die naar jouw e-mailadres is verzonden."
          this.errorDialog.show = true;
        }
        else
        {
          this.formFeedback = 'E-mailadres of wachtwoord is onjuist';
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card
{
  background-color: white;
  border-radius: 5px;
  box-shadow: $default-shadow;
  padding: 25px;
  margin-top: 25px;

  .title
  {
    font-size: 1rem;
    font-weight: bold;
    margin-bottom: 0.3rem;
  }

  .subtitle
  {
    font-size: 1rem;
    font-style: italic;
    margin-bottom: 0.3rem;
  }

  .text-button
  {
    display: block;
    text-align: center;
    text-decoration: underline;
    font-weight: bold;
    margin-bottom: 1rem;
  }

  input[type="text"], input[type="password"]
  {
    box-shadow: $default-shadow;
  }
}

label
{
  font-weight: 500;
}

.form-feedback
{
  text-align: right;
  color: $error;
}
</style>